import { useState } from "react";
import { CalendarRange } from "lucide-react";
import { Input } from "@/components/ui/input";
import { today } from "@/components/washes/WashDialog";

export const usePeriod = () => {
  const t = today();
  return useState({ date_from: `${t.slice(0, 8)}01`, date_to: t });
};

const fd = (d) => (d ? new Date(d).toLocaleDateString("it-IT") : "…");

export const PeriodPicker = ({ value, onChange, prefix }) => {
  const reset = () => { const t = today(); onChange({ date_from: `${t.slice(0, 8)}01`, date_to: t }); };
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 rounded-xl border border-slate-200 bg-white p-3 text-sm" data-testid={`${prefix}-period`}>
      <CalendarRange className="h-4 w-4 text-slate-500" />
      <span className="font-medium text-slate-700">Periodo</span>
      <span className="text-slate-500">Da</span>
      <Input type="date" className="h-9 w-40" value={value.date_from} max={value.date_to || undefined} onChange={(e) => onChange({ ...value, date_from: e.target.value })} data-testid={`${prefix}-date-from`} />
      <span className="text-slate-500">A</span>
      <Input type="date" className="h-9 w-40" value={value.date_to} min={value.date_from || undefined} onChange={(e) => onChange({ ...value, date_to: e.target.value })} data-testid={`${prefix}-date-to`} />
      <button onClick={reset} className="rounded-md px-2 py-1 text-xs font-semibold text-sky-700 hover:bg-sky-50" data-testid={`${prefix}-period-reset`}>Mese in corso</button>
      <span className="text-xs text-slate-500" data-testid={`${prefix}-period-label`}>dal {fd(value.date_from)} al {fd(value.date_to)}</span>
    </div>
  );
};
